import { JSONSchema7 } from 'json-schema';
import JSONSchema7Properties from '../../../Shared/jSONSchema7Properties';

export default (currVer: JSONSchema7): JSONSchema7 => {
  let properties = currVer.properties as JSONSchema7Properties;

  properties['version'].default = 3;

  properties = {
    ...properties,
    conditional: {
      $id: `${currVer.$id}/conditional`,
      default: false,
      type: 'boolean'
    }
  };

  return {
    ...currVer,
    properties
  };
};
